import init from '@/utils/polyfill-ssjdata-in-cardniu'
// eslint-disable-next-line
window._globalSettingReady && window._globalSettingReady(
  () => {
    init().then(() => require('./main'))
  },
  () => {
    init().then(() => require('./main'))
  },
)
